import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class AirQuoteListItem extends SearchModelBase {
    id: number = 0;
    quoteNo: string = '';
    quoteDate: string | null = null;
    fromQuoteDate: string | null = null;
    toQuoteDate: string | null = null;
    operator: string = '';
    hawbNo: string = '';
    customer: string = '';
    commodity: string = '';
    loadingPort: string = '';
    discharge: string = '';
    finalDest: string = '';
    createdAt: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    agentId: number = 0;
    customerId: number = 0;
    u1ID: string = '';
    u2ID: string = '';
    u2Date: string | null = null;
    status: string = '';
    validBy: string | null = null;
    fromValidBy: string | null = null;
    toValidBy: string | null = null;
    plofRec: string = '';
    serviceType: string = '';
    sManID: string = '';
    contactName: string = '';
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    opType: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'quoteDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 2, text: 'Quotation #', width: 100, dataIndex: 'quoteNo', defaultColumnFocus : true}),
        XCol.Create({ col: 3, text: 'Quote By', width: 80, dataIndex: 'operator'}),
        XCol.Create({ col: 4, text: 'Valid By', width: 75, dataIndex: 'validBy', type: XCol.XCellType.Date}),
        XCol.Create({ col: 5, text: 'Customer', width: 120, dataIndex: 'customer'}),
        XCol.Create({ col: 6, text: 'Contact', width: 120, dataIndex: 'contactName'}),
        XCol.Create({ col: 7, text: 'Service Type', width: 80, dataIndex: 'serviceType'}),
        XCol.Create({ col: 8, text: 'Commodity', width: 150, dataIndex: 'commodity'}),
        XCol.Create({ col: 9, text: 'Place of Receipt', width: 120, dataIndex: 'plofRec'}),
        XCol.Create({ col: 10, text: 'Departure Airport', width: 120, dataIndex: 'loadingPort'}),
        XCol.Create({ col: 11, text: 'Arrival Airport', width: 120, dataIndex: 'discharge'}),
        XCol.Create({ col: 12, text: 'Final Destination', width: 120, dataIndex: 'finalDest'}),
        XCol.Create({ col: 12, text: 'Salesperson', width: 80, dataIndex: 'sManID'}),
        XCol.Create({ col: 13, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 14, text: 'Create by', width: 100, dataIndex: 'u1ID'}),
        XCol.Create({ col: 15, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 16, text: 'Update by', width: 100, dataIndex: 'u2ID'}),
        ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return AirQuoteListItem.ExportCollection;
    };
	
    public static OrderBy = { orderBy: AirQuoteListItem.prototype.createdAt, orderByAscending: false };

    public static formatData(data: AirQuoteListItem[]) {
        return data.map((d: AirQuoteListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        quoteDate: {from: 'fromQuoteDate', to: 'toQuoteDate'},
        validBy: {from: 'fromValidBy', to: 'toValidBy'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
    }

}
